interface Props {
  size?: number;
  withDot?: boolean;
  title?: string;
}

function strokeForSize(size: number) {
  if (size >= 80) return { bubble: 2.2, arrow: 2.4 };
  if (size >= 56) return { bubble: 2.6, arrow: 2.8 };
  if (size >= 36) return { bubble: 3, arrow: 3.2 };
  return { bubble: 3.6, arrow: 3.8 };
}

export function Logo({ size = 22, withDot = false, title }: Props) {
  const sw = strokeForSize(size);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      style={{ display: "block", flex: "none" }}
    >
      <path
        d="M8 12 H48 A4 4 0 0 1 52 16 V36 A4 4 0 0 1 48 40 H22 L14 48 V40 H8 A4 4 0 0 1 4 36 V16 A4 4 0 0 1 8 12 Z"
        fill="none"
        stroke="#e6e8eb"
        strokeWidth={sw.bubble}
        strokeLinejoin="round"
      />
      <path
        d="M34 26 L18 26 M24 20 L18 26 L24 32"
        stroke="#5b8cff"
        strokeWidth={sw.arrow}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {withDot && (
        <circle cx="46" cy="12" r="4" fill="#3ad19c" stroke="#0b0d10" strokeWidth="1.5" />
      )}
    </svg>
  );
}
